import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/Login'
import dummy from '@/dummy'
import error404 from '@/components/error-404'
import error500 from '@/components/error-500'
import store from '@/store/store.js'
import common from '@/commom/common.js'
import MainMenu from '@/views/MainMenu'
import '@/dialogDrag/dialogDrag.js'
import _ from 'lodash'
import de from "element-ui/src/locale/lang/de";

Vue.use(Router)

const getLatestVer = async() => {
  return fetch('/version.json?timestep=' + Date.now()).then(res => res.json(), { cache: 'no-store' }).then(data => {
    return data
  })
}
const getPath = async(to) => {
  return to.path
}

const router = new Router({
  mode: 'history',
  routes: [
	{path: '/', redirect: '/sws'}
    ,{path: '/sws', redirect: '/sws/login'}
    ,{path: '/sws/login', name: 'login', component: login}
    ,{path: '/sws/main', name: 'main', component: MainMenu}
    ,{path: '/sws/error-404', name: 'error-404', component: error404}
    ,{path: '/sws/error-500', name: 'error-500', component: error500}
    ,{path: '*', name: 'Error', component: login}
    ,{path: '/sws/dummy', name: 'dummy', component: dummy}
  ]
})

// 页面刷新时，重新赋值token
if (store.state.token != '') {
  let {routes} = router.options;
  let routeData = routes.find(r => r.path === '/sws/main');
  let aRouter = common.setRoute2(store.state.routeList);
  routeData.children = aRouter;
  aRouter.forEach(child => {
    if (!router.getRoutes().some(r => r.name === child.name)) {
      router.addRoute('main', child);
    }
  });
}

router.beforeEach(async(to, from, next) => {
  if (_.isEmpty(to.params)) {
    if (_.includes('modify,detail,delete', to.fullPath.substring(to.fullPath.lastIndexOf('/') + 1))) {
      next(to.fullPath.substring(0, to.fullPath.lastIndexOf('/')))
    }
  }

  if (process.env.NODE_ENV === 'production') {
    //根据版本号来判断是否清除浏览器缓存
    let currentVer = window.localStorage.getItem('CurrentVer')
    let latestVer = (await getLatestVer()).version
    let toPath = await getPath(to)
    if (latestVer != currentVer) {
      window.localStorage.clear()
      window.localStorage.setItem('toPath', toPath)
      window.localStorage.setItem('CurrentVer', latestVer)
      window.location.reload() //强制刷新
    } else if (!_.isEmpty(window.localStorage.getItem('toPath'))) {
      let toPath = window.localStorage.getItem('toPath')
      window.localStorage.removeItem('toPath')
      next(toPath);
    }
  }
  
  var appNm = "信服集团管理系统";
  var moduleNm = "登录";
  if (to.name != null && to.name !== '') {
    moduleNm = to.meta.name === undefined ? "登录" : to.meta.name;
  }
  document.title = appNm + "-" + moduleNm;
  next();
})

export default router;
